<template>
    <footer class="main-footer">
        <div class="newsletter" v-if="globalsIsLoaded">
            <div class="img" data-inview="revealRight" data-delay="100">
                <img
                    width="648"
                    :data-src="globals.footer.infolettre.image.url"
                    :alt="globals.footer.infolettre.image.titre"
                    class="lazyload"
                />
            </div>
            <div class="data">
                <div class="main-title-wrap">
                    <h2 class="title special">{{ globals.footer.infolettre.surtitre }}</h2>
                    <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.59342 15L7.49582 10.0976L12.3982 15L15 12.3982L10.0976 7.50418L15 2.60178L12.3982 0L7.49582 4.9024L2.59342 0L0 2.60178L4.89403 7.50418L0 12.3982L2.59342 15Z"
                            fill="#BEA851"
                        />
                    </svg>
                    <h3 class="title">{{ globals.footer.infolettre.titre }}</h3>
                </div>
                <p class="text">
                    {{ globals.footer.infolettre.texte }}
                </p>
                <form
                    action=""
                    method="post"
                    id="newsletter-subscribe-form"
                    name="newsletter-subscribe-form"
                    class="validate newsletter-form"
                    novalidate
                    @submit.prevent="subscribeToNewsletter"
                >
                    <div class="input full">
                        <input
                            v-model="newsletterData.email"
                            type="email"
                            :placeholder="$t('Email')"
                            name="email"
                            class="email"
                            autocomplete="email"
                            :disabled="Boolean(newsletterData.phoneNumber)"
                        />
                    </div>
                    <span class="newsletter-separator">{{ $t('newsletter-or') }}</span>
                    <div class="input full">
                        <input
                            v-model="newsletterData.phoneNumber"
                            type="tel"
                            :placeholder="$t('Téléphone')"
                            name="phoneNumber"
                            autocomplete="tel"
                            inputmode="tel"
                            :disabled="Boolean(newsletterData.email)"
                            @input="maskNewsletterPhone"
                        />
                    </div>
                    <button type="submit" class="site-btn no-pt" :disabled="isNewsletterSending">
                        {{ $t('form.send') }}
                    </button>
                    <!-- <p class="newsletter-note">{{ $t('newsletter-missing-contact') }}</p> -->
                    <!-- <p class="newsletter-note">{{ $t('newsletter-phone-format') }}</p> -->
                    <p class="newsletter-legal">
                        {{ $t('newsletter-legal-prefix') }}
                        <a
                            href="https://docs.laylo.com/en/articles/6497431-terms-of-service"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ $t('newsletter-legal-terms') }}</a
                        >
                        {{ $t('newsletter-legal-and') }}
                        <a
                            href="https://docs.laylo.com/en/articles/6497219-privacy-and-gdpr-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ $t('newsletter-legal-privacy') }}</a
                        >.
                    </p>

                    <div style="position: absolute; left: -5000px" aria-hidden="true">
                        <input
                            v-model="newsletterData.company"
                            type="text"
                            name="company"
                            tabindex="-1"
                            autocomplete="off"
                        />
                    </div>
                </form>
            </div>
        </div>

        <div class="contact" id="contact">
            <div class="row" v-if="globalsIsLoaded">
                <h3 class="title">{{ $t('Visitez-nous') }}</h3>
                <p class="text"><span v-html="globals.contact.adresse.texte"></span></p>
                <a
                    :href="globals.contact.adresse.lien"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text"
                    >{{ $t('Directions') }}</a
                >
            </div>
            <div class="row" v-if="globalsIsLoaded">
                <h3 class="title">{{ $t('Heures d’ouverture') }}</h3>
                <div class="hours" data-day="1">
                    <p class="text">{{ $t('Lundi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.lundi }}</p>
                </div>
                <div class="hours" data-day="2">
                    <p class="text">{{ $t('Mardi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.mardi }}</p>
                </div>
                <div class="hours" data-day="3">
                    <p class="text">{{ $t('Mercredi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.mercredi }}</p>
                </div>
                <div class="hours" data-day="4">
                    <p class="text">{{ $t('Jeudi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.jeudi }}</p>
                </div>
                <div class="hours" data-day="5">
                    <p class="text">{{ $t('Vendredi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.vendredi }}</p>
                </div>
                <div class="hours" data-day="6">
                    <p class="text">{{ $t('Samedi') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.samedi }}</p>
                </div>
                <div class="hours" data-day="7">
                    <p class="text">{{ $t('Dimanche') }}</p>
                    <p class="text">{{ globals.contact.heuresDouvertures.dimanche }}</p>
                </div>
            </div>
            <div class="row" v-if="globalsIsLoaded">
                <h3 class="title">{{ $t('Contactez-nous') }}</h3>
                <a :href="'tel:' + globals.contact.liensDeContact.tel" class="text">{{
                    globals.contact.liensDeContact.tel
                }}</a>
                <a :href="'mailto:' + globals.contact.liensDeContact.courriel" class="text">{{
                    globals.contact.liensDeContact.courriel
                }}</a>
                <a
                    v-if="globalsIsLoaded"
                    :href="globals.contact.reseaux.facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text"
                    >Facebook</a
                >
                <a
                    v-if="globalsIsLoaded"
                    :href="globals.contact.reseaux.instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text"
                    >Instagram</a
                >
                <a href="#" class="cta" @click.prevent="showContact">
                    <p class="text">{{ $t('Réservation événement') }}</p>
                </a>
            </div>
            <svg
                class="pastille"
                viewBox="0 0 60 79"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M59.8168 55.454C58.7338 55.3368 57.6453 55.2775 56.556 55.2762C55.927 55.2762 55.2981 55.2762 54.6692 55.3377C56.1037 51.1804 56.6025 46.7576 56.1298 42.3852C55.6571 38.0129 54.2246 33.7988 51.9347 30.0441C48.7398 31.1298 45.7513 32.7477 43.0957 34.8294C41.0167 26.8713 36.4256 19.7964 30.0045 14.6561C23.5839 19.8087 18.9974 26.8957 16.927 34.8636C14.2714 32.7818 11.2829 31.164 8.08795 30.0783C5.79627 33.8323 4.36277 38.0464 3.89005 42.4191C3.41732 46.7918 3.91707 51.2149 5.35351 55.3719C4.72459 55.3719 4.09566 55.3104 3.46674 55.3104V58.4208C4.53813 58.4202 5.60864 58.4818 6.67288 58.6054C7.30863 58.6806 7.93072 58.7763 8.55281 58.8994C9.17489 59.0224 9.92003 59.1865 10.6036 59.371C13.5605 60.1804 16.3546 61.4965 18.8617 63.2608C18.8343 63.7165 18.8206 64.1882 18.8206 64.6759C18.8206 65.0792 18.8206 65.4689 18.8206 65.8653C17.9661 65.9542 17.1321 66.0499 16.3186 66.1593C15.6305 66.2459 14.9605 66.3416 14.3088 66.4464C13.6252 66.549 13.0305 66.6583 12.422 66.7814L11.6427 66.9044C9.39629 67.2878 7.22211 68.014 5.19628 69.0578C3.78902 65.6788 3.09098 62.0466 3.14545 58.3866H3.4394V55.2762C2.35006 55.2771 1.26156 55.3364 0.178575 55.454C-0.433566 61.0366 0.535242 66.6789 2.97454 71.7376C2.96411 71.8809 2.96411 72.0249 2.97454 72.1682C2.97625 72.8085 3.19292 73.4296 3.58979 73.932C3.95758 74.3986 4.40691 74.7946 4.916 75.1009C5.81397 75.653 6.77583 76.0938 7.78033 76.4135C8.58015 76.6801 9.48935 76.9398 10.5148 77.1791C10.8839 77.268 11.2667 77.35 11.6632 77.432C15.2025 78.1357 18.7865 78.5925 22.3891 78.7993L24.2212 78.9018L26.0806 78.977H27.3043H28.8766H31.1872H32.7663H33.9831L35.8494 78.9018L37.6746 78.7993C41.2795 78.5925 44.8657 78.1357 48.4073 77.432C48.8038 77.35 49.1798 77.268 49.5489 77.1791C50.5675 76.9398 51.4767 76.6801 52.2834 76.4135C53.2873 76.0923 54.249 75.6516 55.1477 75.1009C55.6541 74.7909 56.1028 74.3954 56.4739 73.932C56.8708 73.4296 57.0875 72.8085 57.0892 72.1682C57.0883 72.024 57.0768 71.8801 57.055 71.7376C59.4791 66.6744 60.4358 61.0333 59.8168 55.454ZM42.4052 39.5942C42.8496 39.143 43.3076 38.7055 43.7724 38.2885C45.7807 36.5161 48.0436 35.0551 50.4855 33.9544C52.0474 37.1748 52.9467 40.6762 53.1299 44.2508C53.3131 47.8253 52.7765 51.4003 51.5519 54.7635C51.4289 55.0985 51.299 55.4471 51.1623 55.7616C47.6594 56.3994 44.2996 57.6613 41.2431 59.4873L40.8056 59.7539C40.6825 59.0087 40.5321 58.2773 40.3544 57.5526C40.1425 56.6776 39.8895 55.8231 39.6024 54.9823C38.849 52.7657 37.8371 50.6455 36.5877 48.6657C37.6528 45.9326 39.1585 43.3923 41.0448 41.146C41.4892 40.5923 41.9472 40.0727 42.4052 39.5942ZM31.5085 20.248C36.0126 24.9541 39.1099 30.8267 40.4501 37.2015C37.9685 39.6743 35.9415 42.5645 34.4617 45.7398C33.5525 44.6256 32.5656 43.5771 31.5085 42.6021V20.248ZM33.1355 49.0964C33.5319 49.6501 33.9011 50.2107 34.2497 50.7849C34.5984 51.3591 35.0085 52.1111 35.3503 52.8357C36.4516 55.0663 37.2318 57.4415 37.6678 59.8906C37.784 60.5195 37.8729 61.1621 37.9481 61.8115C37.9481 62.0576 37.9959 62.3106 38.0164 62.5703C38.0164 62.9463 38.0643 63.3292 38.078 63.7051C38.0916 64.0811 38.078 64.3887 38.078 64.6827C38.078 64.9767 38.078 65.1681 38.078 65.4073C38.078 65.4757 38.078 65.5441 38.078 65.6124H37.9617L36.1844 65.503H35.7195L34.3523 65.4483H34.113L32.5134 65.4073C31.6999 65.4073 30.8727 65.4073 30.0455 65.4073C29.2184 65.4073 28.398 65.4073 27.5845 65.4073L25.937 65.3663H25.7046L24.3374 65.421H23.8657L22.0883 65.5304H21.9653C21.9653 65.462 21.9653 65.3937 21.9653 65.3253C21.9653 65.086 21.9653 64.8468 21.9653 64.6007C21.9653 64.3546 21.9653 63.9171 21.9653 63.6231C21.9653 63.3292 21.9994 62.8643 22.0336 62.4883C22.0336 62.2285 22.0746 61.9756 22.102 61.7295C22.1703 61.0801 22.2592 60.4375 22.3754 59.8086C22.8172 57.36 23.5995 54.9853 24.6997 52.7537C25.0347 52.0701 25.3833 51.3865 25.8003 50.7029C26.2173 50.0193 26.5181 49.5681 26.9078 49.0143C27.844 47.7115 28.8916 46.4924 30.0387 45.3707C31.1813 46.5141 32.2178 47.7588 33.1355 49.0895V49.0964ZM28.5006 20.248V42.6021C27.4452 43.5788 26.4584 44.6272 25.5474 45.7398C24.0723 42.5634 22.0473 39.6728 19.5658 37.2015C20.9019 30.8267 23.9971 24.9536 28.5006 20.248ZM18.7728 59.4873C15.701 57.6694 12.3272 56.4189 8.81258 55.7958C8.68269 55.4676 8.55281 55.1122 8.42976 54.7977C7.20328 51.4348 6.66566 47.8596 6.84887 44.2848C7.03207 40.7099 7.93236 37.2084 9.49619 33.9886C11.9381 35.0893 14.201 36.5503 16.2092 38.3227C16.6809 38.7397 17.139 39.1772 17.5765 39.6284C18.014 40.0795 18.5267 40.6264 18.9437 41.1597C20.8301 43.406 22.3357 45.9462 23.4008 48.6794C22.1492 50.659 21.135 52.7791 20.3793 54.9959C20.0922 55.8368 19.8461 56.6913 19.6273 57.5663C19.4564 58.2909 19.306 59.0224 19.183 59.7675L18.7728 59.4873ZM52.8029 72.9544C50.7521 73.9114 46.2539 75.1078 39.1307 75.6888L37.408 75.8119L35.6648 75.9076C34.4958 75.9623 33.2653 75.9965 31.9802 76.017H28.0494C26.7642 76.017 25.5337 75.9623 24.3579 75.9076L22.6215 75.8119L20.892 75.6888C13.7414 75.1078 9.22958 73.9114 7.21977 72.9544C6.76943 72.7929 6.3591 72.5364 6.01661 72.2024C6.15218 72.0392 6.31673 71.9025 6.50197 71.7991C7.66411 71.0608 10.5695 70.0627 15.3274 69.3313C16.0247 69.2219 16.763 69.1193 17.5423 69.0236L19.1009 68.8527L20.017 68.7639L20.6459 68.7092L22.1977 68.593L23.2778 68.5246L24.1596 68.4767H24.3921H24.98L26.1079 68.4357H26.6822L28.1861 68.4015H30.0182H31.8571L33.361 68.4357H33.8943L35.0291 68.4767H35.617H35.8426L36.7244 68.5246L37.8045 68.593L39.3563 68.7092L39.9921 68.7639L40.9081 68.8527L42.4667 69.0236C43.2392 69.1193 43.9775 69.2219 44.6748 69.3313C49.4601 70.0627 52.3449 71.0608 53.507 71.7991C53.7018 71.9032 53.8774 72.0396 54.0266 72.2024C53.6766 72.5369 53.2595 72.7932 52.8029 72.9544ZM54.8538 69.0578C52.8279 68.014 50.6537 67.2878 48.4073 66.9044L47.5733 66.7335C46.9717 66.6105 46.3428 66.5011 45.6934 66.3986C45.0439 66.296 44.374 66.2003 43.6836 66.1114C42.8701 66.0021 42.0361 65.9064 41.1747 65.8175C41.1747 65.421 41.1747 65.0313 41.1747 64.628C41.1747 64.2247 41.1747 63.6846 41.1405 63.2129C43.6452 61.4487 46.437 60.1326 49.3917 59.3232C50.0753 59.1386 50.7589 58.9814 51.4425 58.8515C52.1262 58.7216 52.6936 58.6327 53.3225 58.5575C54.389 58.4342 55.4618 58.3725 56.5354 58.373H56.8636C56.9244 62.0366 56.231 65.6736 54.8264 69.0578H54.8538Z"
                />
            </svg>
        </div>

        <div class="credits">
            <p class="text">@ Mellön</p>
            <img width="50" src="@/assets/img/pastille.svg" class="pastille" alt="Houblon Mellön" />
            <a href="https://jnv.dev" target="_blank" rel="noopener noreferrer" class="jnv">
                <p class="text">{{ $t('Par') }}</p>
                <img width="40" src="@/assets/img/jnv.svg" alt="J&V Logo" />
            </a>
        </div>

        <section class="overlay-form" :class="{ active: contactIsOpen }">
            <div class="form-wrap">
                <p class="title">{{ $t('Réservation événement') }}</p>
                <img
                    src="@/assets/img/close.svg"
                    class="close"
                    alt="Close"
                    @click.prevent="showContact"
                />
                <form
                    action=""
                    class="form"
                    name="reservation"
                    method="post"
                    accept-charset="UTF-8"
                    @submit="sendForm($event)"
                >
                    <input type="hidden" name="action" value="contact-form/send" />

                    <input
                        type="text"
                        :placeholder="$t('Nom complet')"
                        required
                        v-model="formData.nom"
                    />
                    <input
                        type="mail"
                        :placeholder="$t('Courriel')"
                        class="half"
                        required
                        v-model="formData.courriel"
                    />
                    <input
                        type="tel"
                        :placeholder="$t('Téléphone')"
                        class="half"
                        required
                        v-model="formData.telephone"
                    />
                    <input
                        type="text"
                        :placeholder="$t('Date')"
                        class="half"
                        required
                        v-model="formData.date"
                    />
                    <input
                        type="text"
                        :placeholder="$t('Heure')"
                        class="half"
                        required
                        v-model="formData.heures"
                    />
                    <input
                        type="number"
                        :placeholder="$t('Nombre de personnes')"
                        required
                        v-model="formData.personnes"
                    />

                    <textarea
                        :placeholder="
                            $t(
                                'Donnez-nous plus de détails sur votre événement, nous vous contacterons par la suite.'
                            )
                        "
                        v-model="formData.message"
                    ></textarea>

                    <input type="submit" :value="$t('Réservation événement')" />
                </form>
            </div>
            <div class="overlay" @click.prevent="showContact"></div>
        </section>
    </footer>
</template>

<script>
import axios from 'axios'

import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'

import { mapState, mapGetters } from 'vuex'

import { formatPhoneInput } from '@/utils/mask'

export default {
    data() {
        return {
            contactIsOpen: false,
            formMessage: '',
            formMessageStatus: '',
            isSending: false,
            isNewsletterSending: false,
            newsletterData: {
                email: '',
                phoneNumber: '',
                company: '',
            },
            formData: {
                nom: '',
                telephone: '',
                courriel: '',
                heures: '',
                date: '',
                personnes: '',
                message: '',
            },
        }
    },

    watch: {
        globalsIsLoaded: {
            handler(globalsIsLoaded) {
                if (globalsIsLoaded) {
                    setTimeout(() => {
                        // Highlight today's day
                        const today = new Date()
                        const todayDay = today.getDay()
                        const days = [].slice.call(document.querySelectorAll('.hours'))
                        days.forEach(day => {
                            if (parseInt(day.dataset.day) === todayDay) {
                                day.classList.add('today')
                            }
                        })
                    }, 1)
                }
            },
            immediate: true,
        },
    },

    methods: {
        showContact() {
            if (this.contactIsOpen) {
                this.contactIsOpen = false
            } else {
                this.contactIsOpen = true
            }
        },
        resetNewsletterForm() {
            this.newsletterData = {
                email: '',
                phoneNumber: '',
                company: '',
            }
        },
        maskNewsletterPhone() {
            this.newsletterData.phoneNumber = formatPhoneInput(this.newsletterData.phoneNumber)
        },
        async subscribeToNewsletter() {
            if (this.isNewsletterSending) {
                return
            }

            if (!this.newsletterData.email && !this.newsletterData.phoneNumber) {
                Swal.fire({
                    text: this.$t('newsletter-missing-contact'),
                    icon: 'error',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                })

                return
            }

            this.isNewsletterSending = true

            const formData = new FormData()
            formData.append('email', this.newsletterData.email)
            formData.append('phoneNumber', this.newsletterData.phoneNumber)
            formData.append('company', this.newsletterData.company)

            try {
                await axios.post(
                    `${process.env.VUE_APP_SITE_BASE_URL}/api/send/newsletter-subscribe`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )

                Swal.fire({
                    text: this.$t('newsletter-success'),
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                })

                this.resetNewsletterForm()
            } catch (error) {
                const errorMessage =
                    error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : this.$t('error-when-saving')

                Swal.fire({
                    text: errorMessage,
                    icon: 'error',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                })
            } finally {
                this.isNewsletterSending = false
            }
        },
        async sendForm(e) {
            e.preventDefault()

            if (this.isSending) {
                return
            }

            this.isSending = true

            // this.formData[this.content.content.form.csrfName] = this.content.content.form.csrf
            this.formData['action'] = 'contact-form/send'
            this.formData['formName'] = 'Réservation événement'
            this.formData['sujet'] = 'Réservation événement'

            const formData = new FormData()
            formData.append('nom', this.formData.nom)
            formData.append('courriel', this.formData.courriel)
            formData.append('telephone', this.formData.telephone)
            formData.append('date', this.formData.date)
            formData.append('heures', this.formData.heures)
            formData.append('personnes', this.formData.personnes)
            formData.append('message', this.formData.message)

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }

            await axios
                .post(
                    `${process.env.VUE_APP_SITE_BASE_URL}/api/send/contact-form`,
                    formData,
                    config
                )
                .then(res => {
                    this.formMessage = 'success'
                    this.formMessageStatus = res.status

                    Swal.fire({
                        text: this.$t('email-sent'),
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })

                    this.contactIsOpen = false

                    setTimeout(() => {
                        this.formData = {}

                        this.formMessage = ''
                        this.isSending = false
                    }, 2275)
                })
                .catch(e => {
                    this.formMessage = e

                    setTimeout(() => {
                        this.formData = {
                            nom: '',
                            telephone: '',
                            courriel: '',
                            heures: '',
                            date: '',
                            personnes: '',
                            message: '',
                        }
                        this.formMessage = ''
                        this.isSending = false
                        this.contactIsOpen = false
                    }, 2275)
                })
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/02-Tools/_variables.scss';

.main-footer {
    margin-top: 8vw;

    .credits {
        width: 100%;
        padding: 20px 5vw;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .pastille {
            width: 50px;
        }

        .jnv {
            display: flex;
            align-items: center;

            img {
                width: 40px;
                margin-left: 10px;
            }
        }
    }

    .newsletter {
        padding: 0 5vw;
        display: flex;
        position: relative;
        z-index: 10;

        .img {
            width: 50%;
            min-height: 660px;
        }

        .data {
            width: 50%;
            padding: 3vw 5vw;
            text-align: center;

            .main-title-wrap {
                margin-bottom: 25px;
            }

            .text {
                line-height: 1.5;
                margin-bottom: 30px;
            }

            .newsletter-form {
                width: 300px;
                margin: 0 auto;
            }

            .newsletter-separator {
                display: block;
                margin: 0 auto 12px auto;
                color: $colorAccent2;
                font-size: 12px;
                font-weight: 700;
                letter-spacing: 0.08em;
                text-transform: uppercase;
            }

            .input {
                width: 100%;
                height: auto;
                border: 1px solid $colorAccent4;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 0 auto 12px auto;

                &.full {
                    input[type='email'],
                    input[type='tel'] {
                        width: 100%;
                    }
                }

                input[type='text'],
                input[type='email'],
                input[type='tel'] {
                    width: 100%;
                    height: auto;
                    border: 0;
                    margin: 0;
                    padding: 14px 18px;
                    background-color: transparent;
                    color: $colorAccent1;
                    font-family: 'Raleway', sans-serif;
                    outline: none;

                    &:disabled {
                        opacity: 0.45;
                        cursor: not-allowed;
                    }
                }
            }

            .newsletter-submit {
                width: 300px;
                min-height: 60px;
                margin: 0 auto 12px auto;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid $colorAccent4;
                background-color: $colorAccent2;
                color: #111d19;
                font-family: 'Raleway', sans-serif;
                font-size: 12px;
                font-weight: 700;
                letter-spacing: 0.08em;
                text-transform: uppercase;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover {
                    background-color: $colorAccent3;
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: default;
                }
            }

            .newsletter-note,
            .newsletter-legal {
                width: 300px;
                margin: 0 auto 10px auto;
                font-size: 12px;
                line-height: 1.5;
                color: $colorAccent1;
            }

            .newsletter-legal {
                margin-top: 10px;
                margin-bottom: 0;

                a {
                    color: $colorAccent2;
                    text-decoration: underline;
                }
            }
        }
    }

    .contact {
        width: 100%;
        background-color: #111d19;
        padding: 15vw 5vw 5vw 5vw;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 1;
        margin-top: -10vw;
        overflow: hidden;

        .pastille {
            width: 30vw;
            position: absolute;
            top: -50px;
            right: -10%;
            opacity: 0.1;
            z-index: 1;

            path {
                fill: $colorAccent2;
            }
        }

        .row {
            width: 30%;
            position: relative;
            z-index: 10;

            .title {
                font-size: 18px;
                color: #fff;
                border-bottom: 3px solid $colorAccent2;
                padding-bottom: 10px;
                margin-bottom: 30px;
            }

            .text {
                color: #fff;
                margin-bottom: 15px;
            }

            .cta {
                background-color: $colorAccent2;
                &:hover {
                    background-color: $colorAccent3 !important;
                }
                .text {
                    margin-bottom: 0;
                }
            }

            a.text {
                text-decoration: underline;
                display: block;
                margin-top: 20px;
                transition: all 0.2s ease;

                &:hover {
                    color: $colorAccent2;
                }
            }

            .hours {
                display: flex;
                justify-content: space-between;

                &.today {
                    background-color: #4b624f;
                    padding: 12px 15px;
                    margin-bottom: 15px;
                    border-radius: 3px;
                    .text {
                        margin: 0;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1100px) {
        .newsletter {
            align-items: center;
        }
        .contact {
            margin-top: 5vw;
            padding-top: 7vw;
        }
    }

    @media screen and (max-width: 850px) {
        .newsletter {
            flex-wrap: wrap;

            .img {
                width: 100%;
                min-height: inherit;
            }

            .data {
                width: 100%;
            }
        }
        .contact {
            flex-wrap: wrap;

            .pastille {
                display: none;
            }

            .row {
                width: 100%;
                margin-bottom: 5vw;
            }
        }
        .credits {
            .pastille {
                width: 30px;
            }
        }
    }
}
</style>
